/**
 * Коды проблем файла сезона — общий словарь парсера, линтера и схемы отчёта.
 *
 * Отдельным файлом без импортов: types.ts сужает по нему LintIssue.code, а lint.ts
 * и parse.ts сами импортируют types.ts — так обходится цикл. Студия переводит код в
 * подсказку и место в редакторе, message — только для человека.
 */

/** Ошибки разбора: то, что нельзя даже записать в SeasonContent. */
export const PARSE_ERROR_CODES = [
  "yaml_syntax",
  "invalid_type",
  "missing_field",
  "unknown_key",
  "invalid_value",
  "invalid_duration",
  "invalid_release",
  "invalid_line",
  // Два правила линтера, которые в модель не записать: «0 бесплатных» и «серия 0»
  "free_episodes_range",
  "ordinal_gap",
] as const;
export type ParseErrorCode = (typeof PARSE_ERROR_CODES)[number];

/** Ошибки линтера: публикация невозможна (SEASON_FORMAT §5). */
export const LINT_ERROR_CODES = [
  "format_mismatch",
  "empty_scene",
  "ordinal_gap",
  "free_episodes_range",
  "goal_required",
  "chat_only_field",
  "audio_only_field",
  "missing_asset",
  "unknown_hero",
  "line_too_long",
  "pause_too_long",
  "remind_after_pause",
  "episode_length",
  "banned_term",
  "name_token_typo",
  "rubric_key_format",
  "audio_pause_too_long",
] as const;
export type LintErrorCode = (typeof LINT_ERROR_CODES)[number];

/** Предупреждения линтера: публикация возможна. */
export const LINT_WARNING_CODES = [
  "missing_season_story",
  "missing_episode_story",
  "missing_scene_story",
  "threshold_not_cliffhanger",
  "no_name_in_pilot",
  "episode_too_many_scenes",
  "no_rubrics",
  "duplicate_line",
  "name_possessive",
  "voice_without_words",
] as const;
export type LintWarningCode = (typeof LINT_WARNING_CODES)[number];

/** Все коды без повторов — то, что допускает LintIssueSchema. */
export const LINT_CODES = [
  "yaml_syntax",
  "invalid_type",
  "missing_field",
  "unknown_key",
  "invalid_value",
  "invalid_duration",
  "invalid_release",
  "invalid_line",
  ...LINT_ERROR_CODES,
  ...LINT_WARNING_CODES,
] as const;
export type LintCode = (typeof LINT_CODES)[number];
